import React, { useState, useEffect } from 'react';

const StoreLocator = () => {
    const [location, setLocation] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const getUserLocation = () => {
        if (!navigator.geolocation) {
            setError("Geolocation is not supported by your browser");
            return;
        }

        setLoading(true);
        setError(null);

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const userLoc = {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                };

                setLocation(userLoc);
                setLoading(false);

                // Send to your store locator API
                sendToStoreLocatorAPI(userLoc);
            },
            (err) => {
                setLoading(false);
                switch (err.code) {
                    case err.PERMISSION_DENIED:
                        setError("Location access denied by user");
                        break;
                    case err.POSITION_UNAVAILABLE:
                        setError("Location information unavailable");
                        break;
                    case err.TIMEOUT:
                        setError("Location request timed out");
                        break;
                    default:
                        setError("An unknown error occurred");
                }
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            }
        );
    };

    const sendToStoreLocatorAPI = async (loc) => {
        try {
            const response = await fetch('/api/stores/nearby', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    latitude: loc.latitude,
                    longitude: loc.longitude,
                }),
            });

            const data = await response.json();
            console.log('Nearby stores:', data);
        } catch (err) {
            console.error('Failed to fetch stores:', err);
        }
    };

    // Open location in Google Maps
    const openInGoogleMaps = () => {
        if (!location) return;

        const { latitude, longitude } = location;
        const googleMapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;

        window.open(googleMapsUrl, '_blank');
    };

    // Optional: Auto-detect (uncomment if needed)
    useEffect(() => {
        // getUserLocation();
    }, []);

    return (
        <div style={{ padding: '20px' }}>

            <div style={{ marginBottom: '20px' }}>
                <button
                    onClick={getUserLocation}
                    disabled={loading}
                    style={{ marginRight: '10px', padding: '10px 16px' }}
                >
                    GRAB LOCATION
                </button>
            </div>

            {error && <p style={{ color: 'red' }}>{error}</p>}

            {location && (
                <div>
                    <p>
                        {/* <strong>Your Location:</strong><br /> */}
                        Latitude: {location.latitude.toFixed(6)}<br />
                        Longitude: {location.longitude.toFixed(6)}
                    </p>



                    <button
                        onClick={openInGoogleMaps}
                        disabled={!location}
                        style={{ padding: '10px 16px' }}
                    >
                        VIEW IN MAPS
                    </button>
                </div>
            )}
        </div>
    );
};

export default StoreLocator;